import React from 'react';
import request from "./request";
React.Component.prototype.$axios = request;
export default request;